import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  roleWriting,
} from "../../Data/All_Services_Data/technicalSeoData";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const TechnicalSeoService = () => {
  useMetaTags({
    title: "Technical SEO Services | Technical SEO Company Warrgyizmorsvh",
    description:
      "Technical SEO services from Warrgyizmorsvh help boost rankings, fix site issues, and improve performance. Get expert technical SEO solutions tailored to your website.",
    keywords:
      "technical seo, tech seo, technical seo agencies, technical seo optimization, Technical SEO Services, technical seo companies, advanced technical seo, technical seo strategies, Technical Agency , seo service, seo company, seo services",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Optimize Your Website’s Performance with Our Technical SEO
                Expertise
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        .extra-box{
          display: flex;
          height: 70px;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 25px;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/technicalSeoExpert.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  At Warrgyizmorsch we know that a website’s performance is what
                  drives online success. Our teams’ of experts are dedicated to
                  fine tuning each aspect of your technical foundation your
                  business is built on, we’ll make it perform at the highest
                  level. We work through from site audits to the best practices
                  of speeding up page load times. Also, whether it's fixing
                  technical problems that ruin the user experience or enhancing
                  search engine rankings, we have the skill set that will take
                  your site to a better place.
                </p>
              </div>
            </div>
            {/* Professional Technical SEO Services  */}
            <Handle_Largedata_section LargeData={LargeData} />

            {/* A Smarter Approach to Technical SEO */}
            <Custom_section data={CustomSection} />

            {/* How Technical SEO Can Elevate Your Business Growth  */}
            <Role_writing data={roleWriting} />

            {/* How Warrgyizmorsch Can Accelerate Your Business Growth?  */}
            <Boost_section data={BoostSection} />

            <div className="extra-box"></div>

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default TechnicalSeoService;
